import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const SocialPinterestIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SocialPinterest",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M10.66 29.91c1-1.31 1.8-2.83 2.34-4.48l.03-.11s.21-.74 1.15-4.56a4.71 4.71 0 0 0 3.9 2.06h.16c5.32 0 8.94-4.86 8.94-11.35 0-4.91-4.17-9.48-10.49-9.48-7.87 0-11.83 5.65-11.83 10.34 0 2.83 1.09 5.37 3.45 6.31.08.05.18.07.29.07a.6.6 0 0 0 .58-.48c.08-.29.23-1.02.33-1.33a.799.799 0 0 0-.23-.92 4.87 4.87 0 0 1-1.1-3.09v-.28a7.83 7.83 0 0 1 7.83-7.83h.33-.02c4.45 0 6.89 2.7 6.89 6.33 0 4.78-2.11 8.81-5.24 8.81h-.08a2.59 2.59 0 0 1-2.51-3.23v.02c.5-2.09 1.44-4.31 1.44-5.85 0-1.35-.72-2.5-2.21-2.5-1.72 0-3.18 1.84-3.18 4.31 0 .96.2 1.86.55 2.69l-.02-.05c-1.9 7.66-2.23 9.01-2.23 9.01-.2.98-.31 2.1-.31 3.25 0 .81.06 1.61.16 2.39v-.09h1.08Z"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M16 0C7.18 0 0 7.18 0 16c0 6.88 4.36 12.75 10.46 15.01-.18-1.57-.15-4.13.14-5.37.27-1.17 1.75-7.43 1.75-7.43s-.45-.9-.45-2.22c0-2.08 1.2-3.63 2.71-3.63 1.28 0 1.89.96 1.89 2.11 0 1.28-.82 3.2-1.24 4.98-.35 1.49.75 2.7 2.22 2.7 2.66 0 4.7-2.8 4.7-6.85 0-3.58-2.57-6.09-6.25-6.09-4.26 0-6.75 3.19-6.75 6.49 0 1.29.49 2.66 1.11 3.41.12.15.14.28.1.43-.11.47-.36 1.49-.41 1.7-.06.27-.22.33-.5.2-1.87-.87-3.04-3.6-3.04-5.79 0-4.72 3.43-9.05 9.88-9.05 5.19 0 9.22 3.7 9.22 8.64s-3.25 9.3-7.76 9.3c-1.52 0-2.94-.79-3.43-1.72 0 0-.75 2.86-.93 3.56-.31 1.21-1.66 3.72-2.34 4.86 1.55.5 3.2.77 4.91.77 8.82 0 16-7.18 16-16S24.82 0 16 0"
      })
    })
  }));
};
SocialPinterestIcon.displayName = 'SocialPinterestIcon';